import { useBrand } from '../lib/brand';
import { MarketingShell, Pill, SectionHeading, usePageMeta } from './chrome';
import { coachPage } from './content';
import { CopilotBands } from './CopilotBands';

export default function CopilotPage() {
  const brand = useBrand();
  usePageMeta(`Coaches · ${brand.name}`, coachPage.sub);
  return (
    <MarketingShell>
      <section className="mkt-band mkt-band-pool" data-mkt-surface="dark">
        <div className="px-6 py-mkt-sm md:py-mkt">
          <SectionHeading level="h1" tone="light" title={coachPage.title} sub={coachPage.sub} />
        </div>
      </section>
      <article className="px-6 py-8 md:py-12">
        <div className="mx-auto max-w-[1100px]">
          <CopilotBands level="h2" coachesOnly />
        </div>
      </article>
      <section className="mkt-band mkt-band-tide" data-mkt-surface="dark">
        <div className="px-6 py-20 text-center md:py-28">
          <h2 className="text-balance text-mkt-section-sm text-white md:text-mkt-section">See it poolside.</h2>
          <div className="mt-8">
            <Pill to="/contact" surface="dark">
              Book a demo
            </Pill>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
